<template>
	<div class="printPageContainer">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{
					$t('back') }}
				</b-button>
			</div>
			<div class="pull-right">
				<b-button
					variant="outline-dark"
					class="mr-2"
					@click="print"
				>
					<i class="fa fa-print"></i>
					{{$t('pricing.print')}} {{$t('goods.barcode')}}
				</b-button>
				<!--<b-button
					variant="outline-dark"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{ $t('Печать')}}
				</b-button>
				<b-button
					variant="outline-dark"
					class="mr-2"
				>
					<i class="fa fa-edit"></i>
					{{ $t('Изменить') }}
				</b-button>-->
				<div class="clearfix"></div>
			</div>
			<div class="clearfix"></div>
		</div>
		<template v-for="product in itemsForBacode">
			<div class="printElement text-center" v-for="i in parseInt(product.count)">
				<p class="text-center"> {{ product.name.substring(0, 30) }} <br/>
					<b class="color">{{$t('goods.color')}}: </b> {{ product.colorName}}<br/>
					<b>{{$t('goods.artikul')}}: </b> {{ product.artikul}}<br/>
					<b>{{$t('incomes.create.price')}}: </b>{{ product.priceUzs}}</p>
					<barcode :value="product.barcode" :options="{ height: '40px'}" tag="svg"></barcode>

			</div>
		</template>
	</div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "PriceBarcodeGenerate",
        methods: {
			async removePageSizeStyle() {
				var el = document.getElementById('stylePrintSizeId');
				if (el) {
					el.remove(); // Removes the div with the 'stylePrintSizeId' id
				}
			},
			async setPageSizeStyle(sizeValue) {
				var css = `@page { size: ${sizeValue}; }`,
				head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');

				style.type = 'text/css';
				style.media = 'print';
				style.id = 'stylePrintSizeId';

				if (style.styleSheet){
					style.styleSheet.cssText = css;
				} else {
					style.appendChild(document.createTextNode(css));
				}

				head.appendChild(style);
			},
            goBackToFrom() {
                this.$router.back();
            },
            async print() {
				await this.removePageSizeStyle();
				await this.setPageSizeStyle('landscape');
                window.print();
            }
        },
        computed: {
            ...mapState('prices', [
                'itemsForBacode', 'barcodeCount'
            ]),
        }
    }

</script>
<style scoped>
	body {
		background-color: white !important;
	}
	@page {
		margin: 0;
	}
	@media print {
		html, body {
			margin: 0 !important;
			text-align: center;
			padding: 0 !important;
		}
		/* @page { size: landscape; } */
		.hidden-print {
			display: none;
		}
		.printElement {
			margin-top: 1% !important;
			margin-bottom: 0 !important;
			text-align: center;
			page-break-after: always;
			word-break:break-all;
			width: 50mm !important;
			height: 28mm !important;
		}
		.printElement p {
			width: 100%;
			margin-left: 14mm;
			font-size: 11px !important;
			font-family: monospace;
			text-align: center;
			color: #000000 !important;
			font-weight: bold;
		}

		.card {
			box-shadow: none;
		}
		svg {
			margin-left: 3mm;
			width: 100% !important;
			height: 14mm;
		}
	}


	p {
		margin-bottom: 0px;
		font-size: 10px;
	}

	.printElement svg {
		width: 70mm !important;
		height: 18mm;
	}

</style>


<!--<style scoped lang="scss">-->
<!--	.printPageContainer {-->
<!--		background-color: #ffffff !important;-->
<!--	}-->
<!--	@media print {-->
<!--		* {-->
<!--			-webkit-box-sizing: border-box;-->
<!--			-moz-box-sizing: border-box;-->
<!--			box-sizing: border-box;-->
<!--			margin: 0 !important;-->
<!--			padding: 0 !important;-->
<!--			line-height: 1 !important;-->
<!--		}-->
<!--		.hidden-print {-->
<!--			display: none;-->
<!--		}-->
<!--		.printElement {-->
<!--			width: 58mm !important;-->
<!--			height: 29.8mm !important;-->
<!--			border: none;-->
<!--			padding-left: 5px;-->
<!--			position: relative;-->
<!--		}-->
<!--		.printElement b.color {-->
<!--			font-family: Monospace;-->
<!--			font-size: 8px;-->
<!--			padding-top: 5px;-->
<!--			line-height: 1 !important;-->
<!--		}-->
<!--		.printElement p {-->
<!--			line-height: 1 !important;-->
<!--			font-family: "Arial Narrow", Sans-Serif;-->
<!--			font-size: 12px;-->
<!--		}-->
<!--		.printElement .barcodeImg svg {-->
<!--			display: block;-->
<!--			height: 40px !important;-->
<!--			width: 100%;-->
<!--			margin: 0 auto;-->
<!--		}-->

<!--		.printElement .barcodeImg {-->
<!--			width: 50mm !important;-->
<!--			position: absolute;-->
<!--			bottom: 5px;-->
<!--			right: 4mm;-->
<!--		}-->
<!--		hr {-->
<!--			display: none;-->
<!--		}-->
<!--	}-->
<!--	/*@media print {-->
<!--		* {-->
<!--			-webkit-box-sizing: border-box;-->
<!--			-moz-box-sizing: border-box;-->
<!--			box-sizing: border-box;-->
<!--			margin: 0 !important;-->
<!--			padding: 0 !important;-->
<!--			line-height: 1 !important;-->
<!--			background: white;-->
<!--		}-->
<!--		.hidden-print {-->
<!--			display: none;-->
<!--		}-->
<!--		.printElement {-->
<!--			width: 58mm !important;-->
<!--			height: 30mm !important;-->
<!--			border: none;-->
<!--			padding-left: 5px;-->
<!--			position: relative;-->
<!--			background: white;-->
<!--			svg {-->
<!--				!*width: 58mm !important;*!-->
<!--				!*height: 18mm;*!-->
<!--				display: block;-->
<!--				height: 40px !important;-->
<!--				width: 100%;-->
<!--				margin: 0 auto;-->
<!--			}-->
<!--		}-->
<!--		.printElement p {-->
<!--			line-height: 1 !important;-->
<!--			font-family: "Arial Narrow", Sans-Serif, serif;-->
<!--			font-size: 11px;-->
<!--			margin-bottom: 0;-->
<!--		}-->
<!--	}*/-->
<!--	/*.printElement{-->
<!--		width: 58mm !important;-->
<!--		height: 30mm !important;-->
<!--		!*page-break-after: always;-->
<!--		word-break: break-all;*!-->
<!--		background: white;-->
<!--		svg {-->
<!--			width: 58mm !important;-->
<!--			height: 18mm;-->
<!--		}-->
<!--		p {-->
<!--			margin-bottom: 0;-->
<!--			line-height: 1 !important;-->
<!--			font-family: "Arial Narrow", Sans-Serif, serif;-->
<!--			font-size: 11px;-->
<!--		}-->
<!--	}*/-->
<!--	/*body {-->
<!--		background-color: white !important;-->
<!--	}-->
<!--	@media print {-->
<!--		html, body {-->
<!--			margin: 0;-->
<!--			padding: 0;-->
<!--		}-->
<!--		* {-->
<!--			box-sizing: border-box;-->
<!--		}-->
<!--		!*@page { size: landscape; }*!-->
<!--		.hidden-print {-->
<!--			display: none;-->
<!--		}-->
<!--		!*.printElement {-->
<!--			width: 100mm;-->
<!--			height: 55mm;-->
<!--			color: black;-->
<!--			page-break-after: always;-->
<!--			word-break: break-all;-->
<!--		}-->
<!--		.printElement p {-->
<!--			font-size: 10px;-->
<!--		}-->
<!--		.card {-->
<!--			box-shadow: none;-->
<!--		}-->
<!--		svg {-->
<!--			width: 90mm !important;-->
<!--			height: 14mm;-->
<!--		}*!-->
<!--	}-->

<!--	svg {-->
<!--		width: 90mm !important;-->
<!--	}-->
<!--	p {-->
<!--		font-size: 10px;-->
<!--	}-->

<!--	.printElement svg {-->
<!--		margin-left: 5mm;-->
<!--		height: 14mm;-->
<!--		word-break:break-all;-->
<!--	}*/-->

<!--</style>-->
